/**
 * @project E-School Web
 * @author Vothana CHY
 * @date 2026-07-16
 */

export default defineNuxtRouteMiddleware(() => {
  // If the environment is production and not running locally/dev, redirect to homepage
  if (process.env.NODE_ENV === 'production') {
    return navigateTo('/');
  }
});
